import ArrayPool from "./ArrayPool";

const pool: Array<unknown> = [];

export default class ObjectPool {
    /**
     * Get an object from the pool
     */
    public static Get<T = unknown>(): T {
        if(pool.length) {
            return pool.pop() as T;
        }

        return {} as T;
    }

    /**
     * Release an object back into the pool
     */
    public static Release(obj: unknown): void {
        // Check to make sure it's not null
        if(obj === null) return;

        // Check in case it's an array
        if(Array.isArray(obj)) {
            return ArrayPool.Release(obj);
        }

        // Check if it's not an object
        if(typeof obj !== "object") {
            return;
        }

        for(const i in obj) {
            if(!Object.prototype.hasOwnProperty.call(obj, i)) continue;

            if(Array.isArray(obj[i as keyof typeof obj])) {
                ArrayPool.Release(obj[i as keyof typeof obj]);
            } else if(typeof obj[i as keyof typeof obj] === "object") {
                ObjectPool.Release(obj[i as keyof typeof obj]);
            }

            delete obj[i as keyof typeof obj];
        }

        pool.push(obj);
    }

    public static CheckPool(): Array<unknown> {
        return pool;
    }
}
